import { toast } from "react-toastify";
import { companyConstants } from "../constants";
import { CompanyService } from "../services";

const updateCompanySettings = (createData) => {
    const request = (createData) => {
        return { type: companyConstants.UPDATECOMPANYSETTINGS_REQUEST, createData };
    };
    const success = (companySettings) => {
        return { type: companyConstants.UPDATECOMPANYSETTINGS_SUCCESS, companySettings };
    };
    const failure = (error) => {
        return { type: companyConstants.UPDATECOMPANYSETTINGS_FAILURE, error };
    };

    return (dispatch) => {
        dispatch(request(createData));
        return CompanyService.updateCompanyProfile(createData).then(
            (data) => {
                toast.success("Company profile updated");
                dispatch(success(data));
                return data;
            },
            (error) => {
                toast.error(error.toString());
                dispatch(failure(error.toString()));
                return false;
            }
        );
    };
};

const getCompanySettings = () => {
    const request = () => {
        return { type: companyConstants.GETALL_COMPANYSETTINGS_REQUEST };
    };
    const success = (companySettings) => {
        return { type: companyConstants.GETALL_COMPANYSETTINGS_SUCCESS, companySettings };
    };
    const failure = (error) => {
        return { type: companyConstants.GETALL_COMPANYSETTINGS_FAILURE, error };
    };

    return (dispatch) => {
        dispatch(request());

        return CompanyService
            .getCompanySettings()
            .then((companySettings, error) => {
                if (companySettings) {
                    dispatch(success(companySettings));
                    return companySettings;
                } else {
                    dispatch(failure(error.toString()));
                    return error;
                }
            });
    };
}

export const companyActions = {
    updateCompanySettings,
    getCompanySettings
}